import React, { useCallback } from 'react'
import styled from 'styled-components'
import { Input } from 'antd'
import AccountTemplate from 'components/templates/AccountTemplate'
import FormErrorMessage from 'components/atoms/FormErrorMessage'

export default props => {
  const {
    sendConfirmation,
    config,
    isEmailConfirmation,
    isLoading,
    errorMessage,
  } = props

  const handleOnSubmit = useCallback(
    e => {
      e.preventDefault()
      const email = e.target?.email?.value

      sendConfirmation(email)
    },
    [sendConfirmation],
  )

  return (
    <AccountTemplate
      title={'ご登録メールアドレスの確認'}
      breadcrumbs={props.breadcrumbs}
      bodyClassName="body-home__index"
      config={config}
    >
      <div className="page__even lp-page__padding">
        <div className="page__col1">
          <div className="signup-head">
            <h1 className="page-title">ご登録メールアドレスの確認</h1>
          </div>

          <div className="signup-box">
            <div className="row">
              <div className="col-xs-12">
                <div className="signup-box__wrapper-form">
                  <p className="signup-box__notes ta-c mb10">
                    {isEmailConfirmation ? (
                      <TextWrapper>
                        アカウント新規登録に利用したメールアドレスを入力してください。
                        <br />
                        登録に必要な確認メールを再送信します。
                      </TextWrapper>
                    ) : (
                      <TextWrapper>
                        アカウント承認リンクの有効期限が切れました。
                        <br />
                        アカウント登録を続ける場合は、下記より確認メールを再送してください。
                      </TextWrapper>
                    )}
                  </p>
                  <div className="row">
                    <form onSubmit={handleOnSubmit}>
                      <div className="col-sm-12">
                        {isEmailConfirmation && (
                          <EmailInput>
                            <InputComponent
                              className="w100pa"
                              id="email"
                              name="email"
                              type="email"
                              placeholder={i18n.t('page.shared.l_00046')}
                            />
                          </EmailInput>
                        )}
                        {errorMessage && (
                          // メールアドレスのinputがない時は、揃えるラインがないので
                          // 中央寄せでエラーメッセージを表示する
                          <ErrorWrapper shouldCenter={!isEmailConfirmation}>
                            <FormErrorMessage>{errorMessage}</FormErrorMessage>
                          </ErrorWrapper>
                        )}
                      </div>
                      <div className="col-sm-12 ta-c mt20">
                        <input
                          type="submit"
                          name="commit"
                          value={i18n.t('page.shared.l_00076')}
                          disabled={isLoading}
                          className="button-blue pt15 pb15 w200 sm-w100"
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AccountTemplate>
  )
}

const TextWrapper = styled.span`
  @media (min-width: 992px) {
    display: inline-block;
    margin: 0 -50px;
  }
`

const ErrorWrapper = styled.div`
  ${({ shouldCenter }) =>
    shouldCenter &&
    `
     @media (min-width: 992px) {
    display: flex;
    justify-content: center;
  }
  `}
`

const EmailInput = styled.div`
  margin: 0 auto;
  padding-top: 10px;
  padding-bottom: 20px;
`

const InputComponent = styled(Input)`
  height: 40px;

  &.ant-input {
    border-radius: 6px;
    border-color: #b3b3b3;
    font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3',
      'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'メイリオ', Meiryo,
      'ヒラギノ角ゴシック', 'Hiragino Sans', 'Verdana', 'Osaka',
      'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
    font-size: 14px;
    &::-webkit-input-placeholder {
      color: #b3b3b3;
    }
    &:hover {
      border-color: #23729e;
    }
    &.ant-input-disabled {
      &:hover {
        border-color: #e6d8d8;
      }
    }
    &:focus {
      border-color: #23729e;
      box-shadow: none;
    }
  }
  &.ant-input-affix-wrapper {
    .ant-input {
      height: 40px;
      font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3',
        'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'メイリオ', Meiryo,
        'ヒラギノ角ゴシック', 'Hiragino Sans', 'Verdana', 'Osaka',
        'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
      font-size: 14px;
      &::-webkit-input-placeholder {
        color: #b3b3b3;
      }
      &:hover {
        border-color: #23729e;
      }
      &.ant-input-disabled {
        &:hover {
          border-color: #e6d8d8;
        }
      }
      &:focus {
        border-color: #23729e;
        box-shadow: none;
      }
    }
    :hover .ant-input:not(.ant-input-disabled) {
      border-color: #23729e;
    }
  }
`
